import { render } from "./SendOrderMessage.vue?vue&type=template&id=575af446&scoped=true"
import script from "./SendOrderMessage.vue?vue&type=script&lang=js"
export * from "./SendOrderMessage.vue?vue&type=script&lang=js"

import "./SendOrderMessage.vue?vue&type=style&index=0&id=575af446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575af446"]])

export default __exports__